// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.5
//   protoc               v4.23.4
// source: transport/transport_connection_timeout.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import {
  TransportConnectionTimeoutReason,
  transportConnectionTimeoutReasonFromJSON,
  transportConnectionTimeoutReasonToJSON,
} from "./transport_connection_timeout_reason";
import { TransportDirection, transportDirectionFromJSON, transportDirectionToJSON } from "./transport_direction";

export const protobufPackage = "transport";

export interface TransportConnectionTimeout {
  transportId: string;
  timeout: number;
  direction: TransportDirection;
  reason: TransportConnectionTimeoutReason;
}

function createBaseTransportConnectionTimeout(): TransportConnectionTimeout {
  return { transportId: "", timeout: 0, direction: 0, reason: 0 };
}

export const TransportConnectionTimeout: MessageFns<TransportConnectionTimeout> = {
  encode(message: TransportConnectionTimeout, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.transportId !== "") {
      writer.uint32(10).string(message.transportId);
    }
    if (message.timeout !== 0) {
      writer.uint32(16).uint32(message.timeout);
    }
    if (message.direction !== 0) {
      writer.uint32(24).int32(message.direction);
    }
    if (message.reason !== 0) {
      writer.uint32(32).int32(message.reason);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): TransportConnectionTimeout {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseTransportConnectionTimeout();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.transportId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.timeout = reader.uint32();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.direction = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.reason = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): TransportConnectionTimeout {
    return {
      transportId: isSet(object.transportId) ? globalThis.String(object.transportId) : "",
      timeout: isSet(object.timeout) ? globalThis.Number(object.timeout) : 0,
      direction: isSet(object.direction) ? transportDirectionFromJSON(object.direction) : 0,
      reason: isSet(object.reason) ? transportConnectionTimeoutReasonFromJSON(object.reason) : 0,
    };
  },

  toJSON(message: TransportConnectionTimeout): unknown {
    const obj: any = {};
    if (message.transportId !== "") {
      obj.transportId = message.transportId;
    }
    if (message.timeout !== 0) {
      obj.timeout = Math.round(message.timeout);
    }
    if (message.direction !== 0) {
      obj.direction = transportDirectionToJSON(message.direction);
    }
    if (message.reason !== 0) {
      obj.reason = transportConnectionTimeoutReasonToJSON(message.reason);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<TransportConnectionTimeout>, I>>(base?: I): TransportConnectionTimeout {
    return TransportConnectionTimeout.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<TransportConnectionTimeout>, I>>(object: I): TransportConnectionTimeout {
    const message = createBaseTransportConnectionTimeout();
    message.transportId = object.transportId ?? "";
    message.timeout = object.timeout ?? 0;
    message.direction = object.direction ?? 0;
    message.reason = object.reason ?? 0;
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
